import React from 'react';
import ReactDOM from 'react-dom';
import '@studiouxp/abc-mallorca-portal-ds/styles.css'
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
